(function(){
  document.querySelectorAll('.kko-hdr').forEach(function(hdr){
    var burger = hdr.querySelector('[data-kko-burger]');
    var panel = hdr.querySelector('[data-kko-mobile]');
    if(burger && panel){
      burger.addEventListener('click', function(){
        var open = panel.classList.toggle('is-open');
        burger.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    }
    // Panier : ouvrir le tiroir Vue du thème (wetheme-right-drawer) au lieu de naviguer vers /cart.
    hdr.querySelectorAll('.js-drawer-open-right-link').forEach(function(link){
      link.addEventListener('click', function(e){
        e.preventDefault();
        document.documentElement.dispatchEvent(new CustomEvent('wetheme-toggle-right-drawer', {
          detail: { type: 'cart', forceOpen: true, params: {} }
        }));
      });
    });
  });
})();
